
import { useEffect, useState } from 'react';
import { MDBContainer} from 'mdb-react-ui-kit';
import { SectionOne, SectionTwo, SectionThree, SectionFour, SectionFive, SectionSix } from './components'
import { GithubPicker, /* TwitterPicke */ } from 'react-color'
import './App.css';


function App() {

  //>>> to implement: change --website-main-color var on css
  //

  const [myColor, setMyColor] = useState("#ffe500");

  const handleChangeComplete = (color) => {
    setMyColor(color.hex);
    
  }

  useEffect(() => { 
    //::: change index.css var(--website-main-color) everytime the state gets updated
    document.documentElement.style.setProperty('--website-main-color', myColor);
  }, [myColor])

  return (
    <MDBContainer fluid className="App">
      <div style={{ position: 'fixed', top: '10px', left: '10px'}}>
        <GithubPicker width={'365px'} triangle={'top-left'} color={ myColor } colors={['#ffe500', '#DB3E00', '#FFB60D', '#E7E80C', '#807300', '#1273DE', '#FF197C', '#3800FF', '#C60DFF', '#FAD0C3', '#FF350D', '#E6CF00', '#AAFF0D', '#C4DEF6']} onChangeComplete={ handleChangeComplete }/>
        {/* <TwitterPicker colors={['#ffe500', '#DB3E00', '#FFB60D', '#E7E80C', '#807300', '#1273DE', '#FF197C', '#3800FF', '#C60DFF', '#FAD0C3', '#FF350D', '#E6CF00', '#AAFF0D', '#C4DEF6']} onChangeComplete={handleChangeComplete}/> */}
      </div>
      <SectionOne sectionId='section-1' sectionSelector='#section-2'/>
      <SectionTwo sectionId='section-2' sectionSelector='#section-3' sectionImage="https://www.vivandtimhome.com/wp-content/uploads/2020/10/midcentury-modern-home-office-decor-ideas-4.jpg" />
      <SectionThree sectionId='section-3' sectionSelector='#section-4' sectionImage="https://images.unsplash.com/photo-1520466809213-7b9a56adcd45?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80" />
      <SectionFour sectionId='section-4' sectionSelector='#section-5' />
      <SectionFive sectionId='section-5' sectionSelector='#section-6' sectionImage="https://images.unsplash.com/photo-1604092038795-ecd577310c83?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80" />
      <SectionSix sectionId='section-6' sectionSelector='#section-1' sectionImage="https://images.unsplash.com/photo-1435820394963-a15297f976fd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1944&q=80"/>
    </MDBContainer>
  );
}

export default App;


